export const GNOSIS_NONCE_STORAGE_KEY = 'gallery_gnosis_nonce';
export const MOBILE_GALLERY_LAYOUT_STORAGE_KEY = 'gallery_mobile_gallery_layout';
export const USER_SIGNIN_ADDRESS_LOCAL_STORAGE_KEY = 'gallery_user_signin_address';
export const FEED_MODE_KEY = 'gallery_feed_mode';

export const TEZOS_ANNOUNCEMENT_STORAGE_KEY = 'gallery_tezos_announcement_09_25_22';

export const DEBUG_USERNAME_KEY = 'debug_username';

export const GLOBAL_BANNER_STORAGE_KEY = 'GLOBAL_BANNER_STORAGE_KEY';
